(function () {
  if (window.__aknesProductInfoReady) return;
  window.__aknesProductInfoReady = true;

  const ROOT_SELECTOR = '.product-information[data-testid="product-information"]';
  const SKU_SELECTOR = '[data-aknes-variant-sku][data-source="variant_sku"]';
  const VARIANT_SUBTITLE_SELECTOR = '[data-aknes-variant-subtitle]';

  function updateSkuBlocks(root, variant) {
    if (!root || !variant) return;

    root.querySelectorAll(SKU_SELECTOR).forEach((skuBlock) => {
      const valueNode = skuBlock.querySelector('.aknes-product-sku-value');
      const wrapper = skuBlock.closest('.aknes-product-block--sku') || skuBlock;
      const nextSku = variant.sku || '';

      if (valueNode) valueNode.textContent = nextSku;
      if (skuBlock.dataset.hideWhenEmpty === 'true') {
        wrapper.hidden = nextSku === '';
      }
    });
  }

  function parseJson(script) {
    if (!script || !script.textContent) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function parseMapping(mappingText) {
    return String(mappingText || '')
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => {
        const separatorIndex = line.indexOf('::');
        if (separatorIndex === -1) return null;
        return {
          key: normalize(line.slice(0, separatorIndex)),
          value: line.slice(separatorIndex + 2).trim(),
        };
      })
      .filter((item) => item && item.key && item.value);
  }

  function matchManualSubtitle(variant, mappingText) {
    if (!variant) return '';

    const mappings = parseMapping(mappingText);
    if (!mappings.length) return '';

    const candidates = [
      variant.option1,
      variant.option2,
      variant.option3,
      variant.title,
      ...(Array.isArray(variant.options) ? variant.options : []),
    ].map(normalize).filter(Boolean);

    const match = mappings.find((item) => candidates.includes(item.key));
    return match?.value || '';
  }

  function getVariantSubtitle(block, variant) {
    const data = parseJson(block.querySelector('[data-aknes-variant-subtitle-json]'));
    if (!data) return '';

    if (data.source === 'variant_metafield') {
      return data.variantMetafields?.[String(variant?.id)] || '';
    }

    if (data.source === 'custom_fallback') {
      return data.showFallbackWhenEmpty ? data.fallbackText || '' : '';
    }

    const mappedSubtitle = matchManualSubtitle(variant, data.mappingText);
    if (mappedSubtitle) return mappedSubtitle;

    return data.showFallbackWhenEmpty ? data.fallbackText || '' : '';
  }

  function updateVariantSubtitles(root, variant) {
    if (!root) return;

    root.querySelectorAll(VARIANT_SUBTITLE_SELECTOR).forEach((block) => {
      const textNode = block.querySelector('.aknes-variant-subtitle-text');
      const subtitle = getVariantSubtitle(block, variant);

      if (textNode) textNode.textContent = subtitle;
      block.hidden = subtitle === '';
    });
  }

  function updateAknesProductInfo(root, variant) {
    if (!root || !variant) return;
    if (root.dataset.aknesVariantId === String(variant.id)) return;

    root.dataset.aknesVariantId = String(variant.id);
    updateSkuBlocks(root, variant);
    updateVariantSubtitles(root, variant);
  }

  function initializeRoot(root) {
    if (!root || root.dataset.aknesProductInfoReady === 'true') return;
    root.dataset.aknesProductInfoReady = 'true';

    const subtitleScript = root.querySelector('[data-aknes-variant-subtitle-json]');
    const subtitleData = parseJson(subtitleScript);
    const currentVariant = subtitleData?.currentVariant || null;
    if (currentVariant) updateAknesProductInfo(root, currentVariant);
  }

  document.addEventListener('variant:update', (event) => {
    const root = event.target?.closest?.(ROOT_SELECTOR) || document.querySelector(ROOT_SELECTOR);
    updateAknesProductInfo(root, event.detail?.resource);
  });

  document.addEventListener('variant:selected', (event) => {
    const root = event.target?.closest?.(ROOT_SELECTOR) || document.querySelector(ROOT_SELECTOR);
    updateAknesProductInfo(root, event.detail?.variant);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target?.querySelectorAll?.(ROOT_SELECTOR).forEach(initializeRoot);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target?.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => {
      delete root.dataset.aknesProductInfoReady;
    });
  });

  document.querySelectorAll(ROOT_SELECTOR).forEach(initializeRoot);
})();
